import { chatsActions } from "../../actionTypes";

const initialState = {
	users: [],
	fetching: false,
	fetched: false,
	fetchingNext: false,
	nextPageUrl: null,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case chatsActions.FETCH_CHATABLE_USERS: {
			return { ...initialState, fetching: true };
		}

		case chatsActions.FETCH_CHATABLE_USERS_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				nextPageUrl: action.payload.next_page_url,
				users: action.payload.data,
			};
		}

		case chatsActions.FETCH_CHATABLE_USERS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		case chatsActions.FETCH_CHATABLE_USERS_NEXT: {
			return { ...state, fetchingNext: true };
		}

		case chatsActions.FETCH_CHATABLE_USERS_NEXT_FULFILLED: {
			return {
				...state,
				fetchingNext: false,
				nextPageUrl: action.payload.next_page_url,
				users: [...state.users, ...action.payload.data],
			};
		}

		default:
			return state;
	}
};

export default Reducer;
